/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { SetFaultOverrideActionArgs } from "../../../skills/actions/set_fault_override/set_fault_override";
import { TriggerArgs_ChannelCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface FaultOverrideOnPolicyChangeActionArgs {
  trigger:
    | TriggerArgs_ChannelCallback
    | undefined;
  /** The fault override to be executed when the policy changes. */
  faultOverrideArgs:
    | SetFaultOverrideActionArgs
    | undefined;
  /** Fault will trigger when the policy changes from this value to the next. */
  fromPolicy: number;
  toPolicy: number;
}

function createBaseFaultOverrideOnPolicyChangeActionArgs(): FaultOverrideOnPolicyChangeActionArgs {
  return { trigger: undefined, faultOverrideArgs: undefined, fromPolicy: 0, toPolicy: 0 };
}

export const FaultOverrideOnPolicyChangeActionArgs = {
  encode(message: FaultOverrideOnPolicyChangeActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_ChannelCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.faultOverrideArgs !== undefined) {
      SetFaultOverrideActionArgs.encode(message.faultOverrideArgs, writer.uint32(18).fork()).ldelim();
    }
    if (message.fromPolicy !== 0) {
      writer.uint32(24).uint32(message.fromPolicy);
    }
    if (message.toPolicy !== 0) {
      writer.uint32(32).uint32(message.toPolicy);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FaultOverrideOnPolicyChangeActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFaultOverrideOnPolicyChangeActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_ChannelCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.faultOverrideArgs = SetFaultOverrideActionArgs.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.fromPolicy = reader.uint32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.toPolicy = reader.uint32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FaultOverrideOnPolicyChangeActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_ChannelCallback.fromJSON(object.trigger) : undefined,
      faultOverrideArgs: isSet(object.faultOverrideArgs)
        ? SetFaultOverrideActionArgs.fromJSON(object.faultOverrideArgs)
        : undefined,
      fromPolicy: isSet(object.fromPolicy) ? globalThis.Number(object.fromPolicy) : 0,
      toPolicy: isSet(object.toPolicy) ? globalThis.Number(object.toPolicy) : 0,
    };
  },

  toJSON(message: FaultOverrideOnPolicyChangeActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_ChannelCallback.toJSON(message.trigger);
    }
    if (message.faultOverrideArgs !== undefined) {
      obj.faultOverrideArgs = SetFaultOverrideActionArgs.toJSON(message.faultOverrideArgs);
    }
    if (message.fromPolicy !== 0) {
      obj.fromPolicy = Math.round(message.fromPolicy);
    }
    if (message.toPolicy !== 0) {
      obj.toPolicy = Math.round(message.toPolicy);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FaultOverrideOnPolicyChangeActionArgs>, I>>(
    base?: I,
  ): FaultOverrideOnPolicyChangeActionArgs {
    return FaultOverrideOnPolicyChangeActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FaultOverrideOnPolicyChangeActionArgs>, I>>(
    object: I,
  ): FaultOverrideOnPolicyChangeActionArgs {
    const message = createBaseFaultOverrideOnPolicyChangeActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_ChannelCallback.fromPartial(object.trigger)
      : undefined;
    message.faultOverrideArgs = (object.faultOverrideArgs !== undefined && object.faultOverrideArgs !== null)
      ? SetFaultOverrideActionArgs.fromPartial(object.faultOverrideArgs)
      : undefined;
    message.fromPolicy = object.fromPolicy ?? 0;
    message.toPolicy = object.toPolicy ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
